import * as React from 'react';
import "./login.scss"

export default function Logout() {
	return <div>
		<h1>Logged Out</h1>
		<div className="container" style={{backgroundColor: "#f1f1f1"}}>
		</div>
	</div>;
}

